import React, { useRef, useEffect, useState } from 'react';

import CloseIcon from "../../assets/images/close.png";

import { addIncident, getRisk, closeOverlay, getLevels} from "../../store/actions/riskActions";
import {saveIncident, deleteIncident} from "../../store/actions/incidentActions";
import { connect } from "react-redux";
import { compose } from "redux";


import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';


import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver"; // For saving the generated file


const exportToWord = (data, incident_id) => {
    // Create a new Document
    const doc = new Document({
        sections: [
            {
                children: [
                    new Paragraph({
                        children: [
                            new TextRun({
                                text: "Incident Report | " + incident_id,
                                bold: true,
                                size: 24,
                            }),
                        ],
                        spacing: {
                            after: 200, // Add spacing after the paragraph
                        },
                    }),
                    ...data.map((item) =>
                        new Paragraph({
                            children: [new TextRun(item.name + ": " + item.value)],
                            spacing: {
                                after: 200, // Add spacing after each paragraph
                            },
                        })
                    ),
                ],
            },
        ],
    });

    // Generate the document and trigger a download
    Packer.toBlob(doc).then((blob) => {
        saveAs(blob, "Incident Report | " + incident_id + ".docx");
    });
};



const IncidentOverlay = ({deleteIncidentFN, saveIncidentFN, risk_id, closeIncident, addIncidentFN, currentIncident, not_editable, risk, getRiskFN, levels, getLevelsFN, is_new }) => {

    //console.log("Incident Overlay RIsk:" ,risk)

    const [formState, setFormState] = useState({
        incident_description: currentIncident ? currentIncident.description : '',
        incident_risk: '',
        incident_status: currentIncident? currentIncident.status : 'Open' ,
        incident_root_cause: currentIncident ? currentIncident.root_cause : '',
        incident_impact: currentIncident ? currentIncident.impact : '',
        incident_corrective_action: currentIncident ? currentIncident.corrective_action : '',
        incident_preventive_measures: currentIncident ? currentIncident.preventive_measures : ''
    });

    const [showCloseWarning, setShowCloseWarning] = useState(false);
    const [editable, setEditable] = useState(true)
    const [selectedImpact, setSelectedImpact] = useState({
        financial: '',
        operational: '',
        reputational: '',
    })
    const [riks_id, set_risk_id] = useState(true)

    useEffect(() => {
        //console.log("not_editable ", not_editable)
          if (not_editable) {
            setEditable(!not_editable)
            
          }
        }, [not_editable]);
    
    // useEffect(() => {
    //     //console.log("not_editable ", not_editable)
    //       if (risk) {
    //         console.log(risk)
            
    //     }
    // }, [risk]);

    useEffect(() => {
        //console.log("not_editable ", not_editable)
        if (risk && levels) {
            const matchedFinancial = levels.riskImpacts.find(
                (item) => item.impact === risk.financial_residual
            );
            setSelectedImpact(prev => ({
                ...prev,
                financial: matchedFinancial
                    ? `$ ${matchedFinancial.financial_low} - ${matchedFinancial.financial_high}`
                    : '',
                operational: levels.riskImpacts.find(
                    (item) => item.impact === risk.operational_residual
                )?.operational || '',
                reputational: levels.riskImpacts.find(
                    (item) => item.impact === risk.reputational_residual
                )?.reputational || '',
            }));

            //console.log(selectedImpact)
        }
    }, [risk, levels]);

    useEffect(() => {
        getLevelsFN();
    }, [getLevelsFN]);

    useEffect(() => {
        //console.log("new Incident risk", risk)
        if (is_new === true) {
            setFormState(prev => ({
                ...prev,               
                incident_risk: risk.Title,     
            }
            ));

        }
    
    }, [risk]);

    useEffect(() => {
        //console.log("not_editable ", not_editable)
        if (currentIncident) {
            //set_risk_id(currentIncident.risk_id)
            setFormState(prev => ({
                ...prev,
                incident_description: currentIncident ? currentIncident.description : '',
                incident_risk: currentIncident.title,
                incident_status: currentIncident? currentIncident.status : '' ,
                incident_root_cause: currentIncident ? currentIncident.root_cause : '',
                incident_impact: currentIncident ? currentIncident.impact : '',
                incident_corrective_action: currentIncident ? currentIncident.corrective_action : '',
                incident_preventive_measures: currentIncident ? currentIncident.preventive_measures : ''
            }
            ));
            getRiskFN(currentIncident.risk_id)
            console.log("Status: ",currentIncident.status)
        }
        }, [currentIncident]);


    const handleChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        NotificationManager.info('Incident Report Submitted', 'Info', 3000);

        //////console.log(formState);
        addIncidentFN(risk_id, formState);
        closeIncident();

    };

    const handleSave = (e) => {
        e.preventDefault();
       
        saveIncidentFN(currentIncident.incident_id, formState);
        closeIncident();

    };

    const handleDelete = () => {

        deleteIncidentFN(currentIncident.incident_id);
        closeIncident();

    };

    const handleStatusChange = (e) => {
        const { value } = e.target;

        if (value === 'Closed') {
            // Instead of immediately setting Closed, show warning
            setShowCloseWarning(true);
        } else {
            setFormState((prev) => ({
                ...prev,
                incident_status: value,
            }));
        }
    };


    return (
        <div className="p-6 bg-white rounded-lg">
            <form onSubmit={handleSubmit}>
                {/* Title and Definition */}
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-1xl font-semibold text-[#3b3b3b]">Incident Report</h1>
                    <img src={CloseIcon} alt="Close" className="w-8 h-8 cursor-pointer" onClick={() => closeIncident()} />
                </div>
                <div className="mb-6">

                    <label className='text-sm font-semibold text-[#3b3b3b]'>Description</label>
                    <textarea
                        name="incident_description"
                        value={formState.incident_description}
                        onChange={handleChange}
                        placeholder="Describe Incident"
                        className="w-full p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black"
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                <div className="mb-6">

                    <label className='text-sm font-semibold text-[#3b3b3b]'>Related Risk</label>
                    <textarea
                        name="incident_root_cause"
                        value={formState.incident_risk}
                        onChange={handleChange}
                        placeholder="Related Risk Title"
                        className="w-full p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black"
                        required
                        readOnly
                    />
                </div>


                {selectedImpact && (
                    <div className="mt-6 py-4">
                        <div className='text-sm font-semibold text-[#3b3b3b] mb-4'>Impact Summary</div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div className="p-4 border border-gray-200 rounded-lg shadow-sm bg-white hover:shadow-md transition">
                                <label className="block text-sm font-semibold text-gray-600 mb-2">Financial Impact</label>
                                <p className="text-base font-medium text-[#3b3b3b]">{selectedImpact.financial || 'N/A'}</p>
                            </div>

                            <div className="p-4 border border-gray-200 rounded-lg shadow-sm bg-white hover:shadow-md transition">
                                <label className="block text-sm font-semibold text-gray-600 mb-2">Operational Impact</label>
                                <p className="text-base font-medium text-[#3b3b3b]">{selectedImpact.operational || 'N/A'}</p>
                            </div>

                            <div className="p-4 border border-gray-200 rounded-lg shadow-sm bg-white hover:shadow-md transition">
                                <label className="block text-sm font-semibold text-gray-600 mb-2">Reputational Impact</label>
                                <p className="text-base font-medium text-[#3b3b3b]">{selectedImpact.reputational || 'N/A'}</p>
                            </div>
                        </div>
                    </div>
                )}
                <div className="mb-6">

                    <label className='text-sm font-semibold text-[#3b3b3b]'>Root Cause</label>
                    <textarea
                        name="incident_root_cause"
                        value={formState.incident_root_cause}
                        onChange={handleChange}
                        placeholder="Incident Root Cause"
                        className="w-full p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black"
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                <div className="mb-6">

                    <label className='text-sm font-semibold text-[#3b3b3b]'>Impact</label>
                    <textarea
                        name="incident_impact"
                        value={formState.incident_impact}
                        onChange={handleChange}
                        placeholder="Impact"
                        className="w-full p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black"
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                <div className="mb-6">

                    <label className='text-sm font-semibold text-[#3b3b3b]'>Corrective Action</label>
                    <textarea
                        name="incident_corrective_action"
                        value={formState.incident_corrective_action}
                        onChange={handleChange}
                        placeholder="Corrective Action"
                        className="w-full p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black"
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                <div className="mb-6">

                    <label className='text-sm font-semibold text-[#3b3b3b]'>Preventive Measures</label>
                    <textarea
                        name="incident_preventive_measures"
                        value={formState.incident_preventive_measures}
                        onChange={handleChange}
                        placeholder="Preventive Measures"
                        className="w-full p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black"
                        required
                        readOnly={formState.incident_status === "Closed"}
                    />
                </div>

                {is_new !== true && ( <div className="mb-6">
                    <label className="text-sm font-semibold text-[#3b3b3b]">Status</label>
                    <select
                        name="incident_status"
                        value={formState.incident_status}
                        onChange={handleStatusChange}
                        className="w-full p-3 border border-gray-300 rounded bg-[#EEF0ED] text-black"
                        disabled={formState.incident_status === 'Closed'}
                        required
                    >
                        <option value="Open">Open</option>
                        <option value="Closed">Closed</option>
                    </select>
                </div>)}

                {showCloseWarning && (
                    <div className="mt-4 p-4 border border-red-500 bg-red-100 rounded">
                        <p className="text-red-700 font-semibold mb-2">
                            Are you sure you want to mark this as <strong>Closed</strong>? <br />
                            There is no coming back once you confirm.
                        </p>
                        <div className="flex gap-2">
                            <button
                                onClick={() => {
                                    setFormState((prev) => ({
                                        ...prev,
                                        incident_status: "Closed",
                                    }));
                                    saveIncidentFN(currentIncident.incident_id, {
                                        ...formState,
                                        incident_status: "Closed",
                                    });
                                    setShowCloseWarning(false);
                                }}
                                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
                            >
                                Yes
                            </button>
                            <button
                                onClick={() => {
                                    setShowCloseWarning(false);
                                }}
                                className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400 transition"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}

                {(is_new === true && formState.incident_status === "Open") && <button type="submit" className="bg-[#3b3b3b] text-white py-2 px-4 rounded">Submit</button>}

                {(is_new !== true && formState.incident_status === "Open") && <button onClick={handleSave} className="bg-[#3b3b3b] text-white py-2 px-4 rounded">Save and Quit</button>}

                {formState.incident_status !== "Open" && (
                    <div className="flex gap-3">
                        <button
                            type="button"
                            className="bg-[#3b3b3b] text-white py-2 px-4 rounded hover:bg-opacity-70"
                            onClick={() =>
                                exportToWord([
                                    { name: "Incident Description", value: formState.incident_description },
                                    { name: "Incident Root Cause", value: formState.incident_root_cause },
                                    { name: "Impact", value: formState.incident_impact },
                                    { name: "Corrective Action", value: formState.incident_corrective_action },
                                    { name: "Preventive Measures", value: formState.incident_preventive_measures },
                                ], currentIncident.incident_id)
                            }
                        >
                            Export to Word
                        </button>

                        {formState.incident_status === "Closed" && (
                            <button
                                type="button"
                                className="bg-red-600 text-white py-2 px-4 rounded hover:bg-red-700"
                                onClick={() => {
                                   handleDelete()
                                }}
                            >
                                Delete Incident
                            </button>
                        )}
                    </div>
                )}

            </form>
        </div>
    );
};

const mapStateToProps = (state) => {
    console.log("currentIncident", state.incident.incident)
    return {

        risk: state.risk.risk? state.risk.risk.risk : null ,
        currentIncident: state.incident.incident,
        levels: state.risk.levels,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addIncidentFN: (risk_id, incident) => dispatch(addIncident(risk_id, incident)),
        saveIncidentFN: (incident_id, incident) => dispatch(saveIncident(incident_id, incident)),
        deleteIncidentFN: (incident_id) => dispatch(deleteIncident(incident_id)),
        getRiskFN: (risk_id) => dispatch(getRisk(risk_id)),
        closeOverlayFN:() => dispatch(closeOverlay()),
        getLevelsFN: () => dispatch(getLevels()),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(IncidentOverlay);